import React from 'react';

function Help() {
    return (
        <div>
            <h1 style={{ margin: 50, textAlign: 'center' }}>En construction</h1>
        </div>
    );
}

export default Help;